import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const START_SECONDS = 22 * 60 + 22;
export function OfferBanner() {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  const mm = String(Math.floor(seconds / 60)).padStart(2, '0');
  const ss = String(seconds % 60).padStart(2, '0');
  return <>
      <div role="timer" aria-live="off" aria-label={`The offer ends in ${mm} minutes ${ss} seconds`} className="fixed inset-x-0 top-0 z-50 border-b border-grape-deep/40 bg-grape text-white shadow-[0_6px_18px_-10px_rgba(58,36,39,0.6)]" data-id="element-101" data-mp="30svt2xb8ca1d">
        <div className="mx-auto flex h-14 max-w-4xl items-center justify-center gap-4 px-4 sm:gap-8" style={{
        paddingTop: "6px",
        paddingBottom: "8px",
        height: "40px"
      }} data-id="element-102" data-mp="2ry7l2ze9se8v">
          <div className="flex items-center gap-2.5" data-id="element-103" data-mp="3jpwzmmkfmi7f">
            <HourglassIcon className="h-5 w-5 shrink-0 text-lilac-soft" aria-hidden="true" data-id="element-104" data-mp="27p2zs8k39snu" />
            <p className="text-[9px] font-bold uppercase leading-[1.35] tracking-[0.28em] text-lilac-soft sm:text-[10px]" style={{
            fontSize: "8px"
          }} data-id="element-105" data-mp="2cnmlq8yon4g7">
              The offer
              <br data-id="element-106" data-mp="1xx5hyiyks2g5" />
              ends in:
            </p>
          </div>

          <div className="flex items-baseline gap-2 font-display font-black tabular-nums" aria-hidden="true" data-id="element-107" data-mp="22w9u9igsqgap">
            <span className="text-[28px] leading-none sm:text-[32px]" style={{
            fontSize: "21px"
          }} data-id="element-108" data-mp="1p0eidwkte5gt">{mm}</span>
            <span className="text-xs font-bold uppercase tracking-wider" data-id="element-109" data-mp="1f05hw6jshxvm">Min</span>
            <span className="px-1 text-2xl leading-none text-grape-soft" data-id="element-110" data-mp="1f2i794rvnaip">:</span>
            <span className="text-[28px] leading-none sm:text-[32px]" style={{
            fontSize: "21px"
          }} data-id="element-111" data-mp="1jzh0ll3pvdfu">{ss}</span>
            <span className="text-xs font-bold uppercase tracking-wider" data-id="element-112" data-mp="39cc3lzab7x26">Sec</span>
          </div>
        </div>
      </div>
      <div className="h-14" aria-hidden="true" style={{
      backgroundColor: "#FCF9F9",
      backgroundImage: "none",
      paddingBottom: "16px"
    }} data-id="element-113" data-mp="3cvt39chorjka" />
    </>;
}